var generateStyle = function generateStyle(componentTheme) {
  return {
    itemBody: {
      marginLeft: componentTheme.itemBodyMargin
    },
    itemDescription: {
      fontSize: componentTheme.itemBodyFontSize,
      fontWeight: componentTheme.itemBodyFontWeight
    },
    labelWrapper: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
};
export default generateStyle;